import './bootstrap';
import WaveSurfer from 'wavesurfer.js'; 
import ChatBox from './components/ChatBox.js';
import Alpine from 'alpinejs';

window.ChatBox = ChatBox;
window.Alpine = Alpine;
window.WaveSurfer = WaveSurfer;
Alpine.start();
